export default function TrainerEmail({ email }) {
  return (
    <div className="text-base">
      <a
        className="text-green-500 hover:text-gray-900"
        href={`mailto:${email}`}
      >
        {email}
      </a>
    </div>
  );
}
